import { Company } from '~/types/company';
import { IdentityType } from '~/types/company-identity';
import { Counterpart, CounterpartKind } from '~/types/counterparts';
import { CountryIsoCode } from '~/types/country';

export function counterpartName(counterpart?: Counterpart, fallback = ''): string {
  if (counterpart?.kind === CounterpartKind.Virtual) {
    return counterpart.taxNumber || fallback;
  }
  return counterpart?.companyName ?? fallback;
}

export const requiredTaxNumber = (country: CountryIsoCode, identityType: IdentityType) => {
  return country === 'IT' && identityType === IdentityType.Person;
};

export const requiredVatNumber = (country: CountryIsoCode, identityType: IdentityType) => {
  return country !== 'IT' || identityType === IdentityType.Contractor;
};

export const visibleTaxNumber = (country: CountryIsoCode) => {
  return country === 'IT';
};

export const visibleVatNumber = (country: CountryIsoCode, identityType: IdentityType) => {
  return !(country === 'IT' && identityType === IdentityType.Person);
};

export const visibleDestinationCode = (country: CountryIsoCode, identityType: IdentityType | null) => {
  return (
    country === 'IT' && [IdentityType.Company, IdentityType.Contractor, IdentityType.Pa, null].includes(identityType)
  );
};

export const visibleCertifiedEmail = (country: CountryIsoCode) => {
  return country === 'IT';
};

export const defaultDestinationCode = (
  currentDestinationCode: string | null | undefined,
  country: CountryIsoCode,
  identityType: IdentityType,
) => {
  if (country == 'SM') {
    return '2R4GTO8';
  }

  if (country == 'OO') {
    return '0000000';
  }

  if (country !== 'IT') {
    return 'XXXXXXX';
  }

  if (identityType === IdentityType.Person) {
    return '0000000';
  }

  if (identityType === IdentityType.Pa) {
    return currentDestinationCode ?? '999999';
  }

  return currentDestinationCode ?? '0000000';
};

export const defaultTaxNumber = (current: string, country: CountryIsoCode) => {
  if (country === 'IT') {
    return current;
  }
  return '';
};

export const defaultVatNumber = (current: string, country: CountryIsoCode, identityType: IdentityType) => {
  if (country === 'IT' && identityType === IdentityType.Person) {
    return '';
  }
  return current;
};

export const isTheCurrentActiveCompany = (counterpart: Counterpart, activeCompany: Company): boolean => {
  if (counterpart.taxNumber === activeCompany.taxNumber) {
    return true;
  }
  return false;
};
